import { api } from './api';
import type { GoogleDriveConnection } from '../types';

export const googleDriveApi = {
  getOAuthUrl: () =>
    api.get<{ oauth_url: string }>('/drive/oauth/start'),

  getStatus: () =>
    api.get<GoogleDriveConnection>('/drive/status'),

  disconnect: () =>
    api.delete<{ status: string }>('/drive/disconnect'),
};
